var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jbocy8au5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 0v667H0V0h375z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pxpbzpjuhb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.343.402 5.824 5.824L13.99.402a1.372 1.372 0 1 1 1.941 1.941l-5.823 5.824 5.823 5.823a1.372 1.372 0 1 1-1.941 1.941l-5.823-5.823-5.824 5.823a1.372 1.372 0 1 1-1.94-1.941l5.823-5.823L.402 2.343A1.372 1.372 0 1 1 2.343.403z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jbocy8au5a)",
    transform: "translate(-335 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pxpbzpjuhb)",
    transform: "translate(337.167 19.667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004AB9",
    d: "M0 0h16.333v16.333H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledCross);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-cross.2e35a9fb8950b7248187a351d6319238.svg";
export { ForwardRef as ReactComponent };